const RailsUtility = {
  convertToEnumFormat(value: string) {
    return value.replace(' ', '_');
  },

  convertFromEnumFormat(value: string) {
    return value.replace('_', ' ');
  },

  convertStatusToApi(status?: string) {
    if (!status) return status;
    return status.toLowerCase();
  },

  convertStatusFromApi(status?: string) {
    if (!status) return status;
    return status.charAt(0).toUpperCase() + status.slice(1);
  },
};

export default RailsUtility;
